export default function Formats() {
  const formats = [
    { icon: 'ri-presentation-line', title: 'Корпоративный тренинг', desc: 'Интенсив 1–2 дня для всей команды с практикой на реальных кейсах' },
    { icon: 'ri-stack-line', title: 'Модульная программа', desc: '2–8 модулей с практикой между встречами и домашними заданиями' },
    { icon: 'ri-video-chat-line', title: 'Онлайн', desc: 'Живые сессии с ролевыми переговорами через видеосвязь' },
    { icon: 'ri-map-pin-line', title: 'Очный формат', desc: 'Офлайн-обучение в вашем офисе или на площадке в Минске' },
    { icon: 'ri-tools-line', title: 'Практикум', desc: 'Глубокая отработка одного навыка: возражения, закрытие, ценность' },
    { icon: 'ri-hand-heart-line', title: 'Сопровождение', desc: 'Долгосрочная поддержка: разборы, корректировка, аудит звонков' },
  ];

  return (
    <section id="formats" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Форматы обучения
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Выбирайте формат под задачи, бюджет и география команды. Каждый формат можно адаптировать под ваши цели.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {formats.map((f, i) => (
            <div key={i} className="bg-white rounded-xl p-6 border border-gray-100 hover:border-teal-200 hover:shadow-md transition-all duration-300">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mb-4">
                <i className={`${f.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{f.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}